import { apiFetch } from './client';
import { OrderStatus } from './orders';

export type OrdersByStatus = Record<OrderStatus, number>;

export interface RevenueSummary {
  totalGross: number;
  totalPlatformCommission: number;
  totalDelivererRevenue: number;
  totalOrdersCompleted: number;
  currency: string;
}

export interface TopDeliverer {
  delivererId: string;
  completedCount: number;
  totalRevenue: number;
  rating: number | null;
  firstName?: string;
  lastName?: string;
}

export interface SuccessRate {
  delivered: number;
  failed: number;
  cancelled: number;
  successRate: number;
}

type Envelope<T> = { success: true; data: T };

const BASE = '/api/v1/admin/analytics';

export const fetchOrdersByStatus = () =>
  apiFetch<Envelope<OrdersByStatus>>(`${BASE}/orders-by-status`);
export const fetchRevenueSummary = () => apiFetch<Envelope<RevenueSummary>>(`${BASE}/revenue`);
export const fetchTopDeliverers = (limit = 10) =>
  apiFetch<Envelope<TopDeliverer[]>>(`${BASE}/top-deliverers`, { query: { limit } });
export const fetchSuccessRate = () => apiFetch<Envelope<SuccessRate>>(`${BASE}/success-rate`);
